<template>
  <div class="overlay">
   <div class="w-100 h-75">
<!--     <div class="row" style="justify-content:center;  animation: mymove 2s infinite;">-->
     <div class="row" style="justify-content:center; " >
<!--       <img :src="`${publicPath}images/vaults-authlogo.png`" width="200">-->
<!--       <img :src="`${publicPath}pulse.gif`" width="100">-->
       <div class="spinner-1">
         <div class="bounce1"></div>
         <div class="bounce2"></div>
         <div class="bounce3"></div>
       </div>
     </div>
<!--     <div class="row mt-2 mr-1" style="justify-content:center">-->
<!--       <div class="spinner-1-border ml-5"></div>-->
<!--     </div>-->

   </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
<style scoped>
.overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  text-align: center;
  min-height: 300px;
  /*backdrop-filter: blur(5px);*/
  backdrop-filter: brightness(40%);
  /*z-index: 10;*/
  /*background:  #000000;*/
  /*opacity: 0.5;*/
  display: flex;
  align-items: center;
  /*background: whitesmoke !important;*/
  /*background: white !important;*/

}
/*@keyframes mymove {*/
/*  from {left: 0px;}*/
/*  to {left: 200px;}*/
/*}*/
/*Huge thanks to @tobiasahlin at http://tobiasahlin.com/spinkit/ */
.spinner-1 {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner-1 > div {
  width: 18px;
  height: 18px;
  background-color: #7367f0;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner-1 .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner-1 .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
}
</style>

